import ValidationResult, { error, VALID } from "./ValidationResult";
import ParameterValueValidator from "./ParameterValueValidator";
import ActionValue from "../api/models/test-series/ActionValue";

export default class ActionValueValidator {
  static validate(actionValue: ActionValue): ValidationResult {
    if (actionValue.action.parameters.length !== actionValue.parameterValues.length) {
      return error(`Please define all parameter values of "${actionValue.action.name}".`);
    }
    const valid = actionValue.parameterValues
      .map(ParameterValueValidator.validate)
      .map((result) => result.valid)
      .reduce((a, b) => a && b, true);
    return valid ? VALID : error(`Please define all parameter values of "${actionValue.action.name}".`);
  }
}
